module.exports = __webpack_public_path__ + "static/media/mBank-Light.00f3e4c9.woff2";